import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule } from '@nebular/auth';

import { throwIfAlreadyLoaded } from './module-import-guard';
import {
  AnalyticsService,
  LasFilterStorageService,
  LayoutService,
  StateService,
  ToastrService
} from './utils';

import { CommonBackendModule } from './backend/common/common-backend.module';
import { NbDialogModule, NbWindowModule } from '@nebular/theme';

export const NB_CORE_PROVIDERS = [
  ...CommonBackendModule.forRoot().providers,

  AnalyticsService,
  LayoutService,
  StateService,
  ToastrService,
  LasFilterStorageService
];

@NgModule({
  imports: [
    CommonModule,
    NbDialogModule.forChild(),
    NbWindowModule.forChild(),
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
